import useLocalStorage from 'hooks/useLocalStorage';
import { useCallback, useEffect, useState } from 'react';

const CONSENT_KEY = "HR_PORTAL_CONSENT_V2";

export default function useConsent() {
    const [consentAccepted, setConsentAccepted] = useLocalStorage(CONSENT_KEY, false);
    const [isOpen, setIsOpen] = useState(() => !consentAccepted);

    useEffect(() => {
        if (!consentAccepted) setIsOpen(true);
    }, [consentAccepted]);

    const onContinue = useCallback(() => {
        setConsentAccepted(true);
        setIsOpen(false);
    }, [setConsentAccepted]);

    const reOpen = useCallback(() => {
        setIsOpen(true);
    }, []);


    return {isOpen, onContinue, reOpen };
}
